import {h} from 'preact';
import {Mutation} from 'react-apollo';
import {DeleteReview} from '@services/BrandReviews/query.graphql';
import invoke from 'lodash.invoke';
import Button from '@components/common/Button';
import Message from '@components/common/Message';

const lblAreYouSureDeleteReview = upi.i18n.getTextFromKey( 'lbl-areYouSureDeleteReview' );
const lblErrorDeleteReview = upi.i18n.getTextFromKey( 'lbl-errorDeleteReview' );

const DialogDeleteReview = ( props, context ) => {
    const closeModal = () => invoke( context, 'onClose' );
    return (
        <Mutation
            mutation={DeleteReview}
            refetchQueries={[props.refetchQuery]}>
            {( deleteReview, {loading, error} ) =>
                <div className="max-w-sm">
                    <header className="modal-header">
                        <h1 className="h1 font-normal">{lblAreYouSureDeleteReview}</h1>
                    </header>
                    <section className="modal-body">
                        <div className="button-bar mt-8">
                            <Button secondary onClick={closeModal}>No</Button>
                            <Button
                                loading={loading}
                                onClick={() =>
                                    deleteReview( {
                                        variables: {
                                            input: {reviewId: props.submitData.reviewId}
                                        }
                                    } ).then( closeModal )
                                }>
                                Yes
                            </Button>
                        </div>
                    </section>
                    {error &&
                    <Message fail>
                        {lblErrorDeleteReview}
                        {' '}
                        <a href={`tel:${upi.conf.phoneTollFree.replace( '-', '' )}`}>{upi.conf.phoneTollFree}</a>
                    </Message>
                    }
                </div>
            }
        </Mutation>
    );
};

export default DialogDeleteReview;